// iter823 — Kiosk Lock: locks a POS device to the POS screens. Leaving the
// POS requires a manager/admin PIN (verified server-side).

const KEY = 'smarto_kiosk_lock';
const BYPASS = 'smarto_kiosk_bypass';
const OPTOUT = 'smarto_kiosk_optout';

export const KIOSK_ALLOWED_PREFIXES = ['/cashier', '/waiter', '/kds', '/kitchen', '/customer-display'];

export function isKioskEnabled() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function setKioskEnabled(on) {
  try {
    if (on) {
      localStorage.setItem(KEY, '1');
      localStorage.removeItem(OPTOUT);
    } else {
      localStorage.removeItem(KEY);
      // Remember the explicit manager opt-out so POS devices (Android app)
      // don't auto re-enable kiosk on the next launch.
      localStorage.setItem(OPTOUT, '1');
      sessionStorage.removeItem(BYPASS);
    }
  } catch { /* quota */ }
}

// iter824 — POS devices (Android app / ?app=pos launches) get kiosk lock
// automatically, unless a manager explicitly turned it off on this device.
export function autoEnableKioskForPosDevice() {
  try {
    if (localStorage.getItem(OPTOUT) === '1') return;
    if (localStorage.getItem(KEY) !== '1') localStorage.setItem(KEY, '1');
  } catch { /* quota */ }
}

// Session bypass: manager unlocked this device until the app is relaunched.
export function hasKioskBypass() {
  try { return sessionStorage.getItem(BYPASS) === '1'; } catch { return false; }
}

export function grantKioskBypass() {
  try { sessionStorage.setItem(BYPASS, '1'); } catch { /* quota */ }
}

export function isKioskAllowedPath(path) {
  return KIOSK_ALLOWED_PREFIXES.some(p => path === p || path.startsWith(p + '/'));
}
